// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__yYGZn","tagRed":"tag_tagRed__TekPX","tagYellow":"tag_tagYellow__YjhqO","tagBlack":"tag_tagBlack__cvPUA"};